module.exports = __webpack_public_path__ + "img/img-3.b13ef774.png";